module.exports = __webpack_public_path__ + "img/deco-right.84856bb.jpg";